import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "./FeaturedProduct.css";

const FeaturedProduct = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 4,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [featuredProduct, setFeaturedProduct] = useState([]);

  useEffect(() => {
    fetch("https://watch-club-server-samiul-ahmed-96.koyeb.app/watchItems")
      .then((res) => res.json())
      .then((data) => setFeaturedProduct(data));
  }, []);
  return (
    <section id="FeaturedProduct" className="my-4 overflow-hidden">
      <Container>
        <div className="second-heading text-center">
          <h2>Explore Our Featured</h2>
          <h3>
            Our Latest
            <span>Collection</span>
          </h3>
        </div>
      </Container>
      <Row className="">
        <Slider {...settings}>
          {featuredProduct.slice(20, 30).map((item) => (
            <div className="featured-product">
              <img src={item.img} alt="" />
              <div className="featured-item-content">
                <Link to={`/detailsAndBooking/${item._id}`}>
                  <button>
                    <i class="far fa-plus-square"></i>
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </Slider>
      </Row>
    </section>
  );
};

export default FeaturedProduct;
